module.exports = __webpack_public_path__ + "static/media/jbbb.0b384e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/jbbb.png
// module id = 857
// module chunks = 0